import { render, staticRenderFns } from "./userInvoices.vue?vue&type=template&id=7cffaaa2&scoped=true&"
import script from "./userInvoices.vue?vue&type=script&lang=js&"
export * from "./userInvoices.vue?vue&type=script&lang=js&"
import style0 from "./userInvoices.vue?vue&type=style&index=0&id=7cffaaa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cffaaa2",
  null
  
)

export default component.exports